import React from 'react';
import Translate from '../Translate/Translate';
import classnames from '../../helpers/classnames';

type Props = React.ComponentProps<'div'>;

export default function NoRecordsFound({className, display = true, ...props}: {
    display?: boolean
} & Pick<Props, keyof Props>) {
    if (!display) {
        return null;
    }

    return <div {...props} className={classnames(className, [
        'd-flex justify-content-center align-items-center py-5 px-2'
    ])}>
        <Translate message="@common-phrases.no-records-found" className="ms-2"/>
    </div>;
}
